import mapboxgl, { GeoJSONSource } from 'mapbox-gl';
import MapLayer from '../map-layer.enum';

function onRoutesIncidentsClusterClick(
  map: mapboxgl.Map,
  incidentCluster: GeoJSON.Feature<GeoJSON.Point, Record<string, any>>
) {
  const clusterId = incidentCluster.properties?.cluster_id;
  if (!clusterId) return;
  (
    map.getSource(MapLayer.ROUTES_INCIDENTS) as GeoJSONSource
  ).getClusterExpansionZoom(clusterId, (err, zoom) => {
    if (err) return;

    map.easeTo({
      center: incidentCluster.geometry.coordinates as [number, number],
      zoom,
    });
  });
}

export default onRoutesIncidentsClusterClick;
